import React, { FC } from "react";
import { noop } from "src/globalConsts";
import { ModuleIds } from "../../../../globalTypes";
import Modules from "./Modules";

export type MainSectionProps = {
  closeNav?: () => void;
  moduleIds: ModuleIds;
};

const MainSection: FC<MainSectionProps> = ({ closeNav = noop, moduleIds }) => {
  if (!moduleIds.length) return null;
  return <Modules moduleIds={moduleIds} closeNav={closeNav} />;
};

export default MainSection;
